import classNames from "classnames"

import CheckmarkIcon from "./Icons/CheckmarkIcon"
import CircleOutlineCheckIcon from "./Icons/CircleOutlineCheckIcon"
import Typography from "./Typography"
import { Color } from "../../../constants/V2/color"

import {
  getBorderColorClass,
  getStrokeColorClass,
  getTextColorClass,
} from "@utils/V2/color"
import React from "react"

type Props = {
  text: string
  size?: "body-lg" | "body-md"
  answerText?: string
  answerTextPosition?: "below" | "inline"
  iconOverrideColor?: Color
  textColor?: Color
  circled?: boolean
  isNumbered?: boolean
  number?: number
}

const BulletItem = ({
  text,
  size = "body-lg",
  answerText,
  answerTextPosition = "inline",
  iconOverrideColor,
  textColor = Color.Charcoal,
  circled = true,
  isNumbered = false,
  number = 1,
}: Props) => {
  return (
    <div
      className={classNames(
        answerTextPosition === "inline"
          ? "grid grid-cols-[min-content_auto_auto] items-start gap-x-8"
          : "grid grid-cols-[min-content_auto] items-start gap-x-8",
        getTextColorClass(textColor)
      )}
    >
      {isNumbered ? (
        <div
          className={classNames(
            "size-[24px] rounded-full border text-center opacity-70",
            getBorderColorClass(iconOverrideColor ?? textColor)
          )}
        >
          <Typography
            element="span"
            text={String(number)}
            weight="medium"
            size="subscript-sm"
            font="grotesk"
            color={iconOverrideColor ?? textColor}
          />
        </div>
      ) : circled ? (
        <CircleOutlineCheckIcon overrideColor={iconOverrideColor} />
      ) : (
        <CheckmarkIcon
          className={classNames(
            "size-12 self-center",
            getStrokeColorClass(iconOverrideColor ?? textColor)
          )}
        />
      )}

      <div className="flex flex-col">
        <Typography
          color={textColor}
          text={text}
          font="grotesk"
          size={size}
          weight={
            answerTextPosition === "below" && answerText ? "medium" : "book"
          }
          className="mt-px"
        />

        {answerText && answerTextPosition === "below" ? (
          <Typography
            color={textColor}
            text={answerText}
            font="grotesk"
            size={size}
            weight="book"
            className="mt-px opacity-70"
          />
        ) : null}
      </div>

      {answerText && answerTextPosition === "inline" ? (
        <Typography
          color={textColor}
          text={answerText}
          font="grotesk"
          size={size}
          weight="medium"
          className="mt-px self-start justify-self-end text-right"
        />
      ) : null}
    </div>
  )
}

export default BulletItem
